export function formatPhone(phone: string): string {
    if (!phone) {
        return '';
    }

    return phone.length === 11
        ? `+7 (${phone.slice(1, 4)}) ${phone.slice(4, 7)}-${phone.slice(7, 9)}-${phone.slice(9)}`
        : phone;
}

export function toHex(value: string) {
    let result = '';
    for (let i = 0; i < value.length; i++) {
        result += value.charCodeAt(i).toString(16);
    }
    return result;
}

export function fromHex(value: string) {
    if (value.length % 2 !== 0) {
        console.error('Invalid hex string');
        return null;
    }

    let result = '';
    for (let i = 0; i < value.length; i += 2) {
        const hexChar = value.substring(i, i + 2);
        result += String.fromCharCode(parseInt(hexChar, 16));
    }

    return result;
}

export function hasOnlyLatinLetters(string: string) {
    for (const char of string) {
        if (/\p{Letter}/u.test(char) && !/^[A-Za-z]$/.test(char)) return false;
    }
    return true;
}
